/**
 * DataArea Service - Centralized DataArea state management
 * 
 * This module provides functions to manage dataAreaId in localStorage.
 * DataArea is equivalent to "company" in Dynamics AX.
 * 
 * Backend expects X-DataAreaId header for legacy endpoints.
 */

// localStorage keys
const DATA_AREA_ID_KEY = 'dataAreaId';

/**
 * Get dataAreaId from localStorage
 * @returns {string|null} - dataAreaId or null
 */
export const getDataAreaId = () => {
  return localStorage.getItem(DATA_AREA_ID_KEY);
};

/**
 * Set dataAreaId in localStorage
 * @param {string} dataAreaId - The DataArea ID to store
 */
export const setDataAreaId = (dataAreaId) => {
  if (dataAreaId) {
    localStorage.setItem(DATA_AREA_ID_KEY, dataAreaId);
  }
};

/**
 * Clear dataAreaId from localStorage
 */
export const clearDataAreaId = () => {
  localStorage.removeItem(DATA_AREA_ID_KEY);
};

/**
 * Initialize DataArea from existing storage
 * This is useful on app startup to restore DataArea context
 * 
 * @returns {string|null} - dataAreaId if exists, null otherwise
 */
export const initializeDataAreaFromStorage = () => {
  const dataAreaId = getDataAreaId();
  return dataAreaId;
};

/**
 * Clear all DataArea-related data from localStorage
 */
export const clearAllDataAreaData = () => {
  clearDataAreaId();
};

const dataAreaService = {
  getDataAreaId,
  setDataAreaId,
  clearDataAreaId,
  initializeDataAreaFromStorage,
  clearAllDataAreaData
};

export default dataAreaService;
